

















import linkDirective from '@/shared/directives/link-directive';
import scrollPositionDirective from '@/shared/directives/scroll-position-directive';

import IContentItem from '../models/content-item';
import {defineComponent, onMounted, PropType, ref} from "@vue/composition-api";

export default defineComponent({
  name: "ContentItems",
  directives: {
    linkDirective,
    scrollPositionDirective
  },
  props: {
    items: {type: [] as PropType<IContentItem[]>, required: true}
  },
  setup: () => {
    const list = ref<HTMLElement | null>(null);
    const childElement = ref<HTMLElement | null>(null);

    onMounted(() => {
      if (list?.value) {
        childElement.value = list?.value.lastChild as HTMLElement;
      }
    })

    return {
      childElement,
      list
    }
  }
})
